var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#01A7F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6984 35.6018C34.759 35.6018 36.4296 33.9313 36.4296 31.8706C36.4296 29.8099 34.759 28.1394 32.6984 28.1394C30.6377 28.1394 28.9672 29.8099 28.9672 31.8706C28.9672 33.9313 30.6377 35.6018 32.6984 35.6018Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0003 24.0726C37.01 24.0726 41.6638 24.7915 45.1728 25.9995C49.4006 27.455 52 29.6612 52 31.6589C52 33.7407 49.2451 36.0845 44.705 37.5888C41.2726 38.726 36.7558 39.3196 32.0003 39.3196C27.1247 39.3196 22.5078 38.7624 19.0367 37.5763C14.6451 36.0752 12 33.7011 12 31.6589C12 29.6774 14.4819 27.4883 18.6503 26.035C22.1723 24.807 26.9411 24.0726 31.9997 24.0726H32.0003Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3961 27.8877C27.8989 23.548 30.8464 19.8757 33.6459 17.4394C37.0188 14.5041 40.2286 13.3546 41.9591 14.3525C43.7626 15.3925 44.4166 18.9499 43.4516 23.6342C42.7227 27.1758 40.9798 31.3851 38.6041 35.5046C36.1683 39.7282 33.3792 43.4494 30.6179 45.863C27.1237 48.9175 23.7456 50.0228 21.9766 49.0026C20.26 48.0134 19.6035 44.7692 20.427 40.4321C21.1228 36.7676 22.8689 32.2698 25.3953 27.8876L25.3961 27.8877Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4025 35.5158C22.8927 31.1811 21.184 26.7925 20.4707 23.1505C19.6121 18.7623 20.2192 15.4073 21.9481 14.4065C23.7498 13.3634 27.1585 14.5734 30.7348 17.7489C33.4388 20.1497 36.2154 23.7612 38.598 27.8768C41.0408 32.0964 42.8717 36.3713 43.5839 39.969C44.4851 44.5217 43.7557 48.0003 41.9883 49.0235C40.2734 50.0162 37.1353 48.9651 33.7891 46.0856C30.9619 43.6528 27.9371 39.8936 25.4025 35.5157V35.5158Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.213bc907.svg";
export { ForwardRef as ReactComponent };